import { uploadTemplate, imageProcessor } from 'utils';
import { USER_MSG_TYPES } from 'constants';
import * as actions from 'actions';

const onVideoAdded = async (file, props, count) => {
  // preparing upload message

  const { conv_id, tmp_pm } = props;
  const base64_obj = await imageProcessor.process(file, true);
  const { width, height, base64 } = base64_obj;
  const msg = uploadTemplate({ upload_type: USER_MSG_TYPES.VIDEO, data: { width, height, base64, name: file.name, length: file.duration }, increment: count });
  actions.sendMessage({ msgs: [msg], conv_id, tmp_pm });

  // preparing Uploads
  const thumb_processed = await imageProcessor.process(file);
  thumb_processed.file_id = msg.id + '_thumbnail';
  file.file_id = msg.id;
  file.original_uri = thumb_processed.original_uri;
  actions.sendFiles({
    files: [thumb_processed, file],
    u_id: file.file_id,
    g_id: 'chat',
    onSuccess: () => actions.sendMsgUpload({ conv_id, msg_id: file.file_id })
  });
};

const onPhotoAdded = async (file, props, count) => {
  // preparing upload message
  const { conv_id, tmp_pm } = props;
  const base64_obj = await imageProcessor.process(file, true);
  const { width, height, base64 } = base64_obj;
  const msg = uploadTemplate({ upload_type: USER_MSG_TYPES.PHOTO, data: { width, height, base64 }, increment: count });
  actions.sendMessage({ msgs: [msg], conv_id, tmp_pm });

  // preparing Uploads
  const img_processed = await imageProcessor.process(file);
  img_processed.file_id = msg.id;
  actions.sendFiles({
    files: [img_processed],
    u_id: img_processed.file_id,
    g_id: 'chat',
    onSuccess: () => actions.sendMsgUpload({ conv_id, msg_id: img_processed.file_id })
  });
};

export const onMediaAdded = async (files, props) => {
  for (let i = 0; i < files.length; i++) {
    //const type = files[i].type || files[i].mediaType;
    const type = files[i].mediaType;
    type.includes('video') ? await onVideoAdded(files[i], { ...props, i }) : await onPhotoAdded(files[i], props, i + 1);
  }
};



// WEBPACK FOOTER //
// ./src/components/middle/chat/compose_type.js